/* ============
 * All Business Days
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import businessDaysTransformer from './../../transformers/businessDay';

const success = ({ data }, resolve) => {
  const days = businessDaysTransformer.fetchCollection(data.data);

  store.dispatch('fetchBusinessDays', days);
  resolve();
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('business_days')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessDay/all.js